export enum TextBubbleIndex {
  NULL,
  INTRO,
  BEFORE_MINT,
  CURRENT_MINT,
  AFTER_MINT,
}
